import { PhoneAssociationViewModel } from '@apis/model/phoneAssociation/PhoneAssociationViewModel';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { InfoResponse } from '@ul/api';

export const toPhoneAsscociationViewModel = (response: InfoResponse): PhoneAssociationViewModel => {
    const { success, responseCode } = response;
    return {
        responseCode,
        success,
        captchaViewModel: toCaptchaViewModel(response),
        otpViewModel: toOtpViewModel(response),
    };
};
